import React, { FC } from 'react';
import { useTranslate } from 'react-admin';
import { useGetProfileTagsByResource } from '~/hooks/profileTags';
import { Skeleton } from '@material-ui/lab';
import { AutocompleteArrayTextInput } from '.';

interface ProfileTagsFilter {
  className: string;
  resource: 'businesses' | 'individuals' | 'partners';
  onChange?: any;
  value?: string[];
}

const ProfileTagsFilter: FC<ProfileTagsFilter> = (props: any) => {
  const { className, onChange, resource, value } = props;
  const translate = useTranslate();
  const t = (key: string) => translate(`components.ProfileTags.${key}`);
  const { data: allTags, isLoading } = useGetProfileTagsByResource(resource);
  const autocompleteOptions = allTags?.map((tag) => tag?.name);
  if (isLoading) return <Skeleton width={210} height={24} />;
  return (
    <AutocompleteArrayTextInput
      label={t('profileTags')}
      name='tags'
      value={value}
      options={autocompleteOptions}
      onChange={onChange}
      className={className}
      freeSolo={false}
      disableHelperText
    />
  );
};

export default ProfileTagsFilter;
